import { Parser } from "json2csv";
import MembershipList from "./membership-list";
import formatSubscriber from "../../../utils/format-sub";
import ActivityDrawer from "../../../parts/activity-drawer/ActivityDrawer";

const MembershipListController = async ({ req, res, load, locals }) => {
  const { query } = req;

  let page = -1;
  if (typeof query.page !== "undefined") {
    page = query.page;
  }

  const allSubs = locals.activeUser.organizationId
    ? await load("subscribersListExport", {
        memberships: true,
        organizationUser: locals.activeUserToRequest._id,
      })
    : await load("subscribersListExport", { memberships: true });

  const formattedSubs = allSubs.subscriptions.data.map(formatSubscriber);
  const fields = [
    "customer_name",
    "customer_email",
    "phoneNumber",
    "plan.interval",
    "created",
    "current_period_start",
    "status",
  ];

  const json2csvParser = new Parser({ fields, unwind: ["plan"] });
  const csv = json2csvParser.parse(formattedSubs);

  if (query.customer) {
    if (locals.activeUser.organizationId) {
      await load("subscriberInvoices", {
        customer: query.customer,
        organizationUser: locals.activeUserToRequest._id,
      });
    } else {
      await load("subscriberInvoices", { customer: query.customer });
    }
  }

  if (query.customer && query.price) {
    await load("upcomingInvoice", query);
  }

  const modal = query.modal || {};

  locals.modal = {
    "activity-feed": <ActivityDrawer />,
  }[modal.type];
  res.body = (
    <MembershipList
      allSubs={allSubs}
      subscribers={formattedSubs}
      csvString={csv}
      page={page}
      key="members"
    />
  );
};

export default MembershipListController;
